// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/integrations/ticketservice/tickets.actions.go

export const GET_TICKET_CONTEXT =
  "mondoo.integrations.tickets.TicketSystemIntegration.GetTicketContext";
